import { Check } from "lucide-react";

export function VerificationBadge({ status, className = "" }) {
  if (status === "verified" || status === "document_supported") {
    const label = status === "document_supported" ? "Document-supported" : "Verified experience";
    return (
      <span
        data-testid="verification-badge"
        className={`inline-flex items-center gap-1.5 text-[11px] font-mono bg-ink text-white px-2.5 py-1 rounded-full ${className}`}
      >
        <Check className="w-3 h-3" strokeWidth={2.5} /> {label}
      </span>
    );
  }
  return (
    <span
      data-testid="verification-badge-anon"
      className={`inline-flex items-center text-[11px] font-mono text-neutral-400 ${className}`}
    >
      Anonymous experience
    </span>
  );
}

// Distinguishes OFFICIAL / PATIENT / VERIFIED / HOSPITAL / PLATFORM categories.
export function SourceBadge({ source = "NOTTO", updated, className = "" }) {
  return (
    <span
      data-testid="source-badge"
      className={`inline-flex items-center gap-1.5 text-[11px] font-mono text-neutral-500 bg-neutral-100 px-2 py-0.5 rounded border border-neutral-200 ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-neutral-400" />
      Source: {source}{updated ? ` · ${updated}` : ""}
    </span>
  );
}

export function CategoryTag({ kind }) {
  const map = {
    official: { label: "Official Registry Data", cls: "bg-ink text-white" },
    patient: { label: "Patient Experience", cls: "bg-[#F3EAE1] text-[#7E3B1C]" },
    verified: { label: "Verified Experience", cls: "bg-ink text-white" },
    hospital: { label: "Hospital Response", cls: "bg-neutral-800 text-neutral-100" },
    platform: { label: "Platform Information", cls: "text-neutral-500 border border-dashed border-neutral-300" },
  };
  const m = map[kind] || map.platform;
  return (
    <span className={`inline-block font-mono text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-sm ${m.cls}`}>
      {m.label}
    </span>
  );
}
